import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Captcha} from "../../common/Captcha";
import {useState} from "react";
import baseHostname from "../../../../hostname";
import {routes} from "../../../../routes";
import {I18nService} from "../../../../service/i18nService";
import appname from "../../../../appname";

export const DMARCResult = () => {
    const {t} = useTranslation();

    const payload = useSelector(state => state.validation.payload);
    const result = payload.result;
    const score = result.score;
    const domain = payload.domain;

    const results = result?.result || [];
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [email, setEmail] = useState('');

    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    const link = (lang, routeName) => {
        console.log(`${appname}/${lang}/${routes[routeName][lang]}`)
        return `${appname}/${lang}/${routes[routeName][lang]}`
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch(
            baseHostname + '/index.php/fullreport',
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({source: "checker", result, email, domain})
            })
            .then(res => res.ok ? res.json() : null)
            .then(data => {
                if (data) {
                    // TODO do stuff
                }
            })
            .catch(err => console.error('Submit error:', err));
    };

    const handleCaptchaVerified = () => setCaptchaVerified(true);

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="text-center mb-5">
                        <h1 className="fw-bold text-primary">{t('pages.dmarcResults.title')}</h1>
                        <p className="lead">{t('pages.dmarcResults.previewInfo')}</p>
                    </div>

                    <div className="card shadow border-warning mb-4">
                        <div className="card-body">
                            <h4>
                                {t('pages.dmarcResults.score')}:
                                <span
                                    className={`fw-bold ms-2 ${score < 5 ? 'text-danger' : score < 8 ? 'text-warning' : 'text-success'}`}>
                                    {score} / 10
                                </span>
                            </h4>

                            {results.map((entry, i) => (
                                <div key={i} className="mt-4">
                                    <h5 className="fw-semibold">DMARC Entry #{i + 1}</h5>

                                    {entry.mechanisms?.length > 0 && (
                                        <>
                                            <p className="fw-semibold mb-1">{t('pages.dmarcResults.mechanisms')}</p>
                                            <ul className="list-group list-group-flush mb-3">
                                                {entry.mechanisms.map((mech, idx) => (
                                                    <li key={idx} className="list-group-item">
                                                        <code>{mech.key}={mech.value}</code>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}

                                    {entry.warnings?.length > 0 && (
                                        <div className="text-warning">
                                            <p className="fw-semibold mb-1">⚠️ {t('pages.dmarcResults.warningHeader')}</p>
                                            <ul className="list-unstyled">
                                                {entry.warnings.map((warn, idx) => {
                                                    return (
                                                        <li key={idx}>
                                                            {t(`pages.dmarcResults.warnings.${warn.key}`, {
                                                                value: warn.value ?? warn.key
                                                            })}
                                                        </li>
                                                    );
                                                })}
                                            </ul>

                                        </div>
                                    )}

                                    {entry.issues?.length > 0 && (
                                        <div className="text-danger">
                                            <p className="fw-semibold mb-1">❌ {t('pages.dmarcResults.issueHeader')}</p>
                                            <ul className="list-unstyled">
                                                {entry.issues.map((issue, idx) => (
                                                    <li key={idx}>
                                                        {t(`pages.dmarcResults.issues.${issue.key}`, {
                                                            value: issue.value ?? issue.key
                                                        })}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}

                            <div className="mt-3">
                                <small className="text-muted">{t('pages.dmarcResults.partialDisclosure')}</small>
                            </div>
                        </div>
                    </div>

                    {/* CTA: Full Report via Email */}
                    <div className="card border-primary shadow-sm mb-4">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <p className="fw-semibold mb-3 fs-5">
                                    {t('pages.dmarcResults.reportPitch')}
                                </p>

                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">
                                        {t('pages.dmarcResults.emailLabel')}
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control form-control-lg"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder={t('pages.dmarcResults.emailPlaceholder')}
                                        required
                                    />
                                </div>

                                <Captcha onSolutionVerified={handleCaptchaVerified}/>

                                <button
                                    type="submit"
                                    className="btn btn-primary btn-lg w-100 mt-3"
                                    disabled={!captchaVerified || !email}
                                >
                                    📥 {t('pages.dmarcResults.getFullReport')}
                                </button>

                                <p className="text-muted small mt-2">
                                    {t('pages.dmarcResults.emailDisclaimer')}
                                </p>
                            </form>
                        </div>
                    </div>

                    {/* CTA: Upgrade Pitch */}
                    <div className="alert alert-info text-center py-4 px-3 border border-2 border-primary shadow-sm">
                        <h5 className="fw-bold">{t('pages.dmarcResults.fomoFact')}</h5>
                        <p className="mb-3">{t('pages.dmarcResults.fomoPitch')}</p>
                        <a href={link(currentLang, 'pricing')} className="btn btn-outline-primary btn-lg">
                            🚀 {t('pages.dmarcResults.getStarted')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
